import { useEffect, useState } from 'react';
import { api, type Ustawienia } from './api';

/**
 * Ustawienia firmy dla formularzy.
 *
 * Dopóki nie przyjdą z serwera, zwracamy wartości domyślne — te same, co po stronie
 * API. Formularz nie ma prawa migotać wymaganiami, a już zwłaszcza nie ma prawa
 * zablokować zapisu tylko dlatego, że odpowiedź jeszcze nie doszła.
 */
const DOMYSLNE: Ustawienia = { zdjeciaWymaganePrzyKarcie: false };

export function useUstawienia(): Ustawienia {
  const [ustawienia, setUstawienia] = useState<Ustawienia>(DOMYSLNE);

  useEffect(() => {
    let aktualne = true;
    api
      .ustawienia()
      .then((wynik) => {
        if (aktualne) setUstawienia(wynik);
      })
      .catch(() => undefined);

    return () => {
      aktualne = false;
    };
  }, []);

  return ustawienia;
}
